import React from 'react';
import { Col, Form } from 'react-bootstrap';

const FormSelect = ({
      classes,
      title,
      required,
      setData,
      loading,
      options
}) => {
      return (
            <>
                  <Form.Group as={Col} lg={classes ? classes : 6}>
                        <Form.Label>
                              {title}{' '}
                              {required && (
                                    <span className="text-danger">*</span>
                              )}
                        </Form.Label>
                        <Form.Select
                              onChange={(event) => setData(event.target.value)}
                        >
                              <option>Select One</option>
                              {!loading ? (
                                    options.length > 0 ? (
                                          options.map((option, index) => (
                                                <option
                                                      key={index}
                                                      value={option.id}
                                                >
                                                      {option.title}
                                                </option>
                                          ))
                                    ) : (
                                          <option value="">
                                                No data found
                                          </option>
                                    )
                              ) : (
                                    <>
                                          <option value="">Loading</option>
                                    </>
                              )}
                        </Form.Select>
                  </Form.Group>
            </>
      );
};

export default FormSelect;
